import { getAuthAxiosBackend } from "@/helpers/axios"

class LevelThreeServices {
    get(id) {
        return getAuthAxiosBackend().get('LevelThree/getLevelThreeById/' + id.toString())
    }

    getAll(data = {}) {
        return getAuthAxiosBackend().get('LevelThree/all', { params: data })
    }

    add(data) {
        return getAuthAxiosBackend().post('LevelThree/addLevelThree', data)
    }

    edit(id, data) {
        return getAuthAxiosBackend().put('LevelThree/updateLevelThree/' + id, data)
    }

    restore(id, data) {
        return getAuthAxiosBackend().put('LevelThree/restoreLevelThree' + id, data)
    }

    delete(id) {
        return getAuthAxiosBackend().delete('LevelThree/softDeleteLevelThree/' + id.toString())
    }

    forceDelete(id) {
        return getAuthAxiosBackend().delete('LevelThree/deleteLevelThree/' + id.toString())
    }
}

export default new LevelThreeServices()
